export default __webpack_public_path__ + "static/media/parkingmap1.4063f99e.png";